import TranslateData from '~/types/TranslateData';

const langs: TranslateData = {
    '데스크톱 알림': 'Desktop Notifications',
    '아프리카TV를 사용 중이 아니여도 화면 모서리에서 푸시 알림을 받습니다.':
        'Even if you are not using AfreecaTV, you will receive push notifications at the corner of the screen.',
    '웹 브라우저에서 아프리카TV의 알림 표시를 허용해야만 푸시 알림을 받을 수 있습니다.':
        'You can only receive push notifications by allowing AfreecaTV notifications in your web browser.',
    '콘텐츠 종류별로 알림 수신 여부를 설정합니다.':
        'Set whether to receive notifications by content type.',
    '설정 변경 또는 초기화 시, 반드시 저장을 해야 합니다.':
        'When changing or initializing settings, please remember to save the changes.',
    '알림 콘텐츠 설정': 'Notification Contents Settings',
    초기화: 'Reset',
    저장: 'Save',
    '이 브라우저에서 알림 받기': 'Get notifications in this browser',
    '알림 설정': 'Notification Settings',
    '푸시 설정': 'Push Notifications',
    '기록 설정': 'Notification History',
    '알림 설정을 초기화 합니다.': 'Reset notification settings.',
    '변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.':
        'Reset all settings to default.\nSave to apply reset on Notification Settings.',
    '설정이 저장되었습니다.': 'Your settings have been saved.',
    '설정 저장을 실패했습니다.': 'Failed to save settings.',
    '설정 정보를 불러오는 중입니다.': 'Loading configuration.',
    '설정 정보를 저장 중입니다.': 'Configuration is being saved.',
    설정: 'Set',
    해제: 'Unset',
    '오류가 발생하였습니다. 잠시 후 다시 이용해주세요.':
        'An error occurred. Please try again.',
    아프리카TV: 'AfreecaTV',
    '데스크톱 알림은 윈도우10, 크롬 웹브라우저 환경에 최적화 되었습니다.':
        'Desktop notifications are optimized for Windows 10, Chrome Web browser environments.'
};

export default langs;
